import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 10px;\n  /* margin: 28px 0; */\n\n  border-radius: 12px;\n\n  h3 {\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 1.5;\n    letter-spacing: -0.2px;\n    margin-bottom: 12px;\n  }\n\n  p {\n    color: ",
        ";\n    font-size: 16px;\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n    padding: 28px 0;\n  }\n\n  @media (max-width: 768px) {\n    /* padding: 20px; */\n    .ant-row {\n      flex-direction: column;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
export const EmptyWrapper = (param)=>{
    let { description  } = param;
    return /*#__PURE__*/ _jsx(EmptyPassContainer, {
        children: /*#__PURE__*/ _jsx("p", {
            children: description
        })
    });
};
const EmptyPassContainer = styled.div.withConfig({
    componentId: "sc-40896334-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_500);
